/* global window:true */

import React from 'react';
import PropTypes from 'prop-types';
import { FavouriteConstants } from '../Constants';
import FavouriteIconComponent from './FavouriteIconComponent';
import FollowComponent from '../../directory/packages/components/FollowComponent';
import MixpanelConstants from '../mixpanelConstants';
import MediaQuery from 'react-responsive';
import {trackMixpanelEvent} from '../MixpanelHelper';

export default class Favourite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      favourited: props.initialState
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      favourited: newProps.initialState
    });
  }

  getFavouritePayload(currentAction) {
    return this.props.type === 'product' ? {
      actionName: currentAction,
      triggeringComponent: this.props.triggeringComponent,
      productId: this.props.productId,
      name: this.props.name,
      imageUrl: this.props.imageUrl,
      exhibitingOrganisationId: this.props.exhibitingOrganisationId,
      isInnovative: this.props.isInnovative,
      locale: this.props.locale,
      description: this.props.description,
      objectId: this.props.objectId,
      exhibitorLogo: this.props.exhibitorLogo,
      organisationGuid: this.props.organisationGuid
    } : {
      actionName: currentAction,
      triggeringComponent: this.props.triggeringComponent,
      exhibitorId: this.props.exhibitorId,
      packageName: this.props.packageName,
      name: this.props.name,
      standReference: this.props.standReference,
      logo: this.props.logo,
      mainStandHolderName: this.props.mainStandHolderName,
      organisationId: this.props.organisationGuid
    };
  }

  getCurrentAction() {
    const prefix = this.props.type === 'product' ? 'Product' : 'Exhibitor';
    return this.state.favourited ? `${prefix}Favourite` : `${prefix}UnFavourite`;
  }
  getId() {
    return this.props.type === 'product' ? this.props.productId : this.props.exhibitorId;
  }

  getInteractedElement() {
    if ((this.props.isMercuryParticipantShow && this.props.showPlanningEnabled) || this.props.isPrimaryEventEdition) {
      return this.state.favourited ? 'Follow' : 'Unfollow'
    } else if (this.props.showPlanningEnabled && !this.props.isMercuryParticipantShow) {
      return this.state.favourited ? 'Favourite' : 'Unfavourite'
    }
  }

  getMixpanelProperties() {
    const props = this.props;
    let mixpanelProps = {
      exhibitorId: props.exhibitorId,
      exhibitorName:  props.name?.toLowerCase(),
      component: props.component,
      packageName: props.packageName
    }
    if(this.state.favourited){
        mixpanelProps = {...mixpanelProps, entityAdded: props.type === MixpanelConstants.type.product ? MixpanelConstants.type.product : MixpanelConstants.type.exhibitor};
    }
    else{
        mixpanelProps = {...mixpanelProps, entityRemoved: props.type === MixpanelConstants.type.product ? MixpanelConstants.type.product : MixpanelConstants.type.exhibitor};
        if (props.type === MixpanelConstants.type.product && (props.packageName === MixpanelConstants.packageName.silver || props.packageName === MixpanelConstants.packageName.gold)) {
          mixpanelProps = {...mixpanelProps, subComponent: MixpanelConstants.subComponent.priority};
        }
    }

    if(props.component === MixpanelConstants.component.exhibitorDirectory || props.component === MixpanelConstants.component.productDirectory) {
      mixpanelProps = {...mixpanelProps, subComponent : props.isPrioritySlotPremiumExhibitor ? MixpanelConstants.subComponent.priority : MixpanelConstants.subComponent.standard};
    }

    if (props.type === MixpanelConstants.type.product) {
      mixpanelProps = {
        ...mixpanelProps,
        exhibitorId: props.exhibitingOrganisationId,
        productId: props.productId,
        productName: props.name?.toLowerCase(),
        exhibitorName: props.exhibitorName.toLowerCase()
      }
    } else if (props.type === MixpanelConstants.type.exhibitor) {
      const interactedElement = this.getInteractedElement()
      mixpanelProps = {
        ...mixpanelProps,
        element : interactedElement

      }
    }

    return mixpanelProps;
  }

  handleClick() {
    this.setState({
      favourited: !this.state.favourited
    }, () => {
      const currentAction = this.getCurrentAction();
      const favouritePayload = this.getFavouritePayload(currentAction);

      const mixpanelProperties = this.getMixpanelProperties();
      const eventName = this.state.favourited ? MixpanelConstants.eventName.addToShowPlan : MixpanelConstants.eventName.removeFromShowPlan;
      trackMixpanelEvent(eventName, mixpanelProperties);


      if (window && window.showPlanningReduxDispatcher) {
        if (favouritePayload.actionName === FavouriteConstants.exhibitorFavourite) {
          window.showPlanningReduxDispatcher.dispatch({ type: 'exhibitor/EXHIBITOR_ADDED_TO_PLAN', payload: favouritePayload });
        } else if (favouritePayload.actionName === FavouriteConstants.exhibitorUnfavourite) {
          window.showPlanningReduxDispatcher.dispatch({ type: 'exhibitor/EXHIBITOR_REMOVED_FROM_PLAN', payload: favouritePayload });
        } else if (favouritePayload.actionName === FavouriteConstants.productFavourite) {
          window.showPlanningReduxDispatcher.dispatch({ type: 'product/PRODUCT_ADDED_TO_PLAN', payload: favouritePayload });
        } else if (favouritePayload.actionName === FavouriteConstants.productUnfavourite) {
          window.showPlanningReduxDispatcher.dispatch({ type: 'product/PRODUCT_REMOVED_FROM_PLAN', payload: favouritePayload });
        }

        if ((this.props.isMercuryParticipantShow || this.props.isPrimaryEventEdition) && this.props.handleFollowClick !== undefined) {
          this.props.handleFollowClick(this.props.organisationGuid, this.state.favourited);
        }
      }
    });
  }

  render() {
    const isFavourited = this.state.favourited;
    const iconName = isFavourited ? FavouriteConstants.favouriteIconSelected : FavouriteConstants.favouriteIconUnSelectedPath1;
    const isPriority = this.props.isPrioritySlotPremiumExhibitor;
    const prioritySlot = isPriority ? this.props.dtmData.prioritySlot : '';

    const dtmTag = isFavourited
        ? this.props.dtmData.unFavouriteIcon + prioritySlot
        : this.props.dtmData.favouriteIcon + prioritySlot;

    const altSVG = isFavourited ? this.props.translations.removeFromFavourite :
      this.props.translations.addToFavourite;
    const id = this.getId();

    if ((this.props.isMercuryParticipantShow && this.props.showPlanningEnabled) || this.props.isPrimaryEventEdition) {
      return (
        <FollowComponent
          isFollowed={isFavourited}
          translations={this.props.translations}
          organisationId={this.props.organisationGuid}
          dtmData={this.props.dtmData}
          userId={this.props.userId}
          handleClick={this.handleClick}
          exhibitingOrganisationId={this.props.exhibitorId}
          locale={this.props.locale}
        />
      );
    } else if (this.props.showPlanningEnabled && !this.props.isMercuryParticipantShow) {
      return (
        <React.Fragment>
          <MediaQuery maxWidth={1197}>
              <FavouriteIconComponent
                dtmTag={dtmTag}
                id={id}
                exhibitorId={this.props.exhibitingOrganisationId}
                packageName={this.props.packageName}
                handleClick={this.handleClick}
                isFavourited={isFavourited}
                iconName={iconName}
                altSVG={altSVG}
                label={isFavourited ? this.props.translations.remove : this.props.translations.addToMyPlan}
                isPrioritySlotPremiumExhibitor={isPriority ? this.props.dtmData.prioritySlot : ''}
                isVariantC={this.props.isVariantC}
              />
            </MediaQuery>
            <MediaQuery minWidth={1198}>
              <FavouriteIconComponent
                dtmTag={dtmTag}
                id={id}
                exhibitorId={this.props.exhibitingOrganisationId}
                packageName={this.props.packageName}
                handleClick={this.handleClick}
                isFavourited={isFavourited}
                iconName={iconName}
                altSVG={altSVG}
                label={isFavourited ? this.props.translations.removeShortened : this.props.translations.addToMyPlanShortened}
                isPrioritySlotPremiumExhibitor={isPriority ? this.props.dtmData.prioritySlot : ''}
                isVariantC={this.props.isVariantC}
              />
            </MediaQuery>
          </React.Fragment>
      );
    }
    return null;
  }
}

Favourite.propTypes = {
  initialState: PropTypes.bool,
  exhibitorId: PropTypes.string,
  packageName: PropTypes.string,
  organisationGuid: PropTypes.string,
  name: PropTypes.string,
  standReference: PropTypes.string,
  logo: PropTypes.string,
  triggeringComponent: PropTypes.string,
  dtmData: PropTypes.object,
  translations: PropTypes.object,
  showPlanningEnabled: PropTypes.bool,
  mainStandHolderName: PropTypes.string,
  productId: PropTypes.string,
  exhibitorLogo: PropTypes.string,
  imageUrl: PropTypes.string,
  exhibitingOrganisationId: PropTypes.string,
  isInnovative: PropTypes.bool,
  locale: PropTypes.string,
  description: PropTypes.string,
  objectId: PropTypes.string,
  type: PropTypes.string,
  userId: PropTypes.string,
  isPrimaryEventEdition: PropTypes.bool,
  handleFollowClick: PropTypes.func,
  isMercuryParticipantShow: PropTypes.bool.isRequired,
  component: PropTypes.string,
  exhibitorName: PropTypes.string,
  isPrioritySlotPremiumExhibitor: PropTypes.bool,
  isVariantC: PropTypes.bool,
};
